const styles = theme => ({

    inputText1: {
        color: '#333333 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
    },

    submitbuttonlayout_dis: {
        display: 'flex ! important',
        width: '92px',
        height: '20px',
        padding: '8px 24px ! important',
        justifyContent: 'center ! important',
        alignItems: 'center ! important',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '4px ! important',
        background: 'var(--CTA, #999999) ! important',
        marginLeft: '10px ! important'
    },

    submitbuttonlayout: {
        display: 'flex ! important',
        width: '92px',
        height: '20px',
        padding: '8px 24px ! important',
        justifyContent: 'center ! important',
        alignItems: 'center ! important',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '4px ! important',
        background: 'var(--CTA, #F74542) ! important',
        marginLeft: '10px ! important'
    },

    transferCallLayout: {
        background: '#01A473 ! important',
        width: '90% ! important',
        height: '45% ! important',
        borderRadius: '16px ! important',
        margin: '4% 0 0 5%'
    },

    transferCallText: {
        color: '#fff ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: '700 ! important',
    },

    transferCallAgentText: {
        color: '#ffffff',
        fontFamily: 'cardiuma-regular !important',
        fontSize: '14px ! important'
    },

    transferCallSearchField: {
        width: '95%',
        height: '45px',
        backgroundColor: '#fff',
        border: '1px solid #0DBA86',
        borderRadius: '3px',
        flexShrink: 0,
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '20px',
        margin: '3% 0 0 2%',

        '& .MuiAutocomplete-clearIndicator': {
            fill: 'red ! important', // Change this to your desired color
            backgroundColor: '#999'
        }
    },

    transferCallButton: {
        width: '35% ! important',
        height: '42px ! important',
        background: '#F74542 ! important',
        margin: '5% 0 0 62% ! important',
        border: '1px solid white ! important'
    },

    transferCallButtonText: {
        color: 'white ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: '600 ! important',
        textTransform: 'none ! important',
    },

    transferCallClose: {
        width: '24px',
        height: '24px',
        margin: '-12% 0 0 90%',
        color: '#F74542',
        cursor: 'pointer',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal',
    }
})

export default styles
